/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';
import GetPlanData from 'app/utility/GetPlanData.js';

export default function PricingModule(Component) {

    class PricingModule extends React.Component {
        constructor(props) {
            super(props);

            this.changeTerm = this.changeTerm.bind(this);
            this.confirmTermChange = this.confirmTermChange.bind(this);
            this.calculateAddOns = this.calculateAddOns.bind(this);
            this.getAdjustedAddOns = this.getAdjustedAddOns.bind(this);

        }

        changeTerm(e, setRequest) {

            let newTerm = e.currentTarget.dataset.term,
                subscriptionInfo = {},
                confirmation = null,
                currentLimits = this.calculateAddOns(0),
                currentSubscription = this.props.plans.current;

            e.preventDefault();

            this.props.deleteApiError(['SUB_UPDATE', 'SUB_ADDON_UPDATE']);

            if (currentSubscription) {
                if (currentSubscription.addOns.add_on_social && currentSubscription.addOns.add_on_social.qty) {
                    currentLimits = this.calculateAddOns(currentSubscription.addOns.add_on_social.qty);
                }
            }

            confirmation = (
                <ConfirmationModal
                    confirmationType="termupdate"
                    confirmationAction={this.confirmTermChange}
                    subscription={currentSubscription}
                    planTerm={newTerm}
                    planLevel={this.props.user.detail.pubLevel}
                    currentLimits={currentLimits}
                    setRequest={setRequest} />
            );

            this.props.addModal(confirmation);

        }

        confirmTermChange(data, setRequest) {

            data.trackingAction = 'termchange';

            // function passed up to change the caller's state
            // to handle 3DS challenges
            if (setRequest) {
                setRequest(this.confirmTermChange, data);
            }

            this.props.updateSubscription(data);

        }

        calculateAddOns(nextAddOns, nextPlan, nextTerm) {

            let addOns = [],
                newLimits = {},
                basePrice = 0,
                addOnPrices = {},
                addOnQuantities = {},
                constants = this.props.app.config.constants,
                currentSubscription = this.props.plans.current,
                planDetails = {},
                annualBase = 0,
                fixedDiscount = 0,
                percentDiscount = 0,
                planLevel = 0,
                planTerm = 0;

            if (_.isEmpty(currentSubscription) && !_.isEmpty(this.props.user.plan)) {
                currentSubscription = this.props.user.plan;
            }

            if (nextTerm) {
                planTerm = nextTerm;
            } else {
                planTerm = currentSubscription.planTerm;
            }

            if (_.isEmpty(this.props.user.perms) ||
                _.isEmpty(currentSubscription) ||
                _.isEmpty(this.props.plans.details)) {
                return newLimits;
            }

            if (currentSubscription.coupons !== undefined && currentSubscription.coupons.length) {
                for (let i = 0; i < currentSubscription.coupons.length; ++i) {
                    if (nextPlan) {
                        if (currentSubscription.coupons[i].appliesToAllPlans === false) {
                            if (currentSubscription.coupons[i].plans.find(({ code }) => {
                                let planData = GetPlanData.lookupDetails(nextPlan, planTerm);
                                return code === planData.plan_id;
                            }) !== undefined) {
                                continue;
                            }
                        }
                    }
                    if (currentSubscription.coupons[i].type === 'fixed') {
                        fixedDiscount += currentSubscription.coupons[i].currencies[0].amount;
                    } else if (currentSubscription.coupons[i].type === 'percent') {
                        percentDiscount += currentSubscription.coupons[i].percent;
                    }
                }
                percentDiscount = ((100 - percentDiscount) / 100);
            }

            // if nextPlan is passed in... it'll override the props.
            // used in the case where a user is moving to a plus plan and we need to move
            // add-ons across the plans
            if (nextPlan) {
                planDetails = nextPlan;
                planLevel = nextPlan.planLevel;
                basePrice = nextPlan.price[planTerm];
            } else {
                basePrice = currentSubscription.price;
                planLevel = currentSubscription.planLevel;
                planDetails = this.props.plans.details[planLevel];
            }

            let addOnCodes = [],
                currentAddOns = [];
            if (currentSubscription.addOns) {
                currentAddOns = Object.keys(currentSubscription.addOns);
            }
            addOnCodes = _.uniq([].concat(currentAddOns, _.values(planDetails.addOns)));
            addOnCodes.map((addOnCode) => {
                if (constants.SUBSCRIPTION_ADDONS[planLevel] !== undefined) {
                    let configIndex = Object.keys(constants.SUBSCRIPTION_ADDONS[planLevel]).find(index => constants.SUBSCRIPTION_ADDONS[planLevel][index] === addOnCode)
                    if (currentSubscription.addOns && currentSubscription.addOns[addOnCode] !== undefined) {
                        if (!addOnPrices[configIndex]) {
                            addOnPrices[configIndex] = {};
                        }
                        addOnPrices[configIndex][planTerm] = currentSubscription.addOns[addOnCode].unitCost;
                        addOns.push({
                            addOn: parseInt(configIndex),
                            quantity: currentSubscription.addOns[addOnCode].qty
                        });
                    } else {
                        if (!addOnPrices[configIndex]) {
                            addOnPrices[configIndex] = {};
                        }
                        addOnPrices[configIndex][planTerm] = planDetails.addOnPrices[configIndex][planTerm];
                        addOns.push({
                            addOn: parseInt(configIndex),
                            quantity: 0
                        });
                    }
                }
            });


            if (planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
                basePrice = 0.00;
            }
            newLimits.addOnSocialsPrice = 0;
            newLimits.addOnPostsPrice = 0;

            // see if the new addons need to override the existing addOns
            if (nextAddOns && nextAddOns.length) {
                nextAddOns.map((nextAddOn) => {
                    let addOn = addOns.find(({addOn}) => { return addOn === nextAddOn.addOn;});
                    if (addOn) {
                        addOn.quantity = nextAddOn.quantity;
                    }
                });
            }

            newLimits.inputs = parseInt(planDetails.limits.hardLimitInputs, 10);
            newLimits.inputsInUse = newLimits.inputs - this.props.user.perms.resources.inputsAvailable;
            newLimits.outputs = parseInt(planDetails.limits.hardLimitOutputs, 10);
            newLimits.outputsInUse = newLimits.outputs - this.props.user.perms.resources.outputsAvailable;

            addOns.map((addOn) => {
                switch (addOn.addOn) {
                    case constants.SUBSCRIPTION_ADDON_SOCIALS:
                        addOnQuantities = planDetails.addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS];
                        newLimits.inputs = parseInt(planDetails.limits.hardLimitInputs, 10) + (addOn.quantity * addOnQuantities.feeds);
                        newLimits.addOnInputs = (addOn.quantity * addOnQuantities.feeds);
                        newLimits.inputsInUse = newLimits.inputs - this.props.user.perms.resources.inputsAvailable;
                        newLimits.outputs = parseInt(planDetails.limits.hardLimitOutputs, 10) + (addOn.quantity * addOnQuantities.socials);
                        newLimits.addOnOutputs = (addOn.quantity * addOnQuantities.socials);
                        newLimits.outputsInUse = newLimits.outputs - this.props.user.perms.resources.outputsAvailable;
                        newLimits.addOnSocialsPrice = addOn.quantity * addOnPrices[addOn.addOn][planTerm];
                        break;

                    case constants.SUBSCRIPTION_ADDON_POSTS_1:
                        addOnQuantities = planDetails.addOnQuantity[constants.SUBSCRIPTION_ADDON_POSTS_1];
                        newLimits.addOnPosts = addOn.quantity * addOnQuantities.posts;
                        newLimits.addOnPostsPrice = addOn.quantity * addOnPrices[addOn.addOn][planTerm];
                        break;

                    default:
                        break;

                }

            });


            newLimits.baseInputs = parseInt(planDetails.limits.hardLimitInputs, 10);
            newLimits.baseOutputs = parseInt(planDetails.limits.hardLimitOutputs, 10);


            newLimits.price = basePrice + newLimits.addOnSocialsPrice + newLimits.addOnPostsPrice;

            if (planTerm == constants.SUBSCRIPTION_TERM_ANNUAL) {
                newLimits.annualMonthlyPrice = (newLimits.price / 12).toPrecision(4)
            }

            if (fixedDiscount) {
                newLimits.price -= fixedDiscount;
            }

            if (percentDiscount) {
                let discountPrice = (newLimits.price * percentDiscount),
                    discountParts = discountPrice.toString().split(".");

                if (discountParts.length > 1) {
                    newLimits.price = `${discountParts[0]}.${discountParts[1].substring(0, 2)}`;
                } else {
                    newLimits.price = `${discountParts[0]}.00`;
                }
            }

            return newLimits;

        }

        getAdjustedAddOns(plan) {
            let constants = this.props.app.config.constants,
                adjustedAddOns = 0;

            if (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_social) {
                // check if the user needs add ons in the upgraded plan
                if (this.props.isAgencyUser(plan) || this.props.isAgencyPlusUser(plan)) {
                    let currentAddOn = this.props.plans.current.addOns.add_on_social,
                        nextOutputBase = this.props.isAgencyUser(plan) ? this.props.plans.details[constants.PUB_LEVEL_8].limits.hardLimitOutputs : this.props.plans.details[constants.PUB_LEVEL_10].limits.hardLimitOutputs,
                        nextInputBase = this.props.isAgencyUser(plan) ? this.props.plans.details[constants.PUB_LEVEL_8].limits.hardLimitInputs : this.props.plans.details[constants.PUB_LEVEL_10].limits.hardLimitInputs,
                        currentOutputBase = this.props.plans.details[this.props.plans.current.planLevel].limits.hardLimitOutputs,
                        currentInputBase = this.props.plans.details[this.props.plans.current.planLevel].limits.hardLimitInputs,
                        currentOutputTotal = 0,
                        currentInputTotal = 0;

                    // convert since the data is coming over as a string
                    nextOutputBase = parseInt(nextOutputBase);
                    nextInputBase = parseInt(nextInputBase);
                    currentOutputBase = parseInt(currentOutputBase);
                    currentInputBase = parseInt(currentInputBase);

                    currentOutputTotal = currentOutputBase + (currentAddOn.qty * currentAddOn.benefits.socials);
                    currentInputTotal = currentInputBase + (currentAddOn.qty * currentAddOn.benefits.feeds);

                    // if the user is moving to agency and has fewer feeds and socials than the
                    // limits, don't attach any add ons
                    if (currentOutputTotal < nextOutputBase && currentInputTotal < nextInputBase) {
                        return 0;
                    }

                }

                if (this.props.isPlusUser(plan) || this.props.isAgencyPlusUser(plan)) {
                    if (this.props.plans.current.addOns.add_on_social.qty > 1) {
                        adjustedAddOns = (this.props.plans.current.addOns.add_on_social.qty * 2) - 1;
                        if (parseInt(this.props.plans.current.planLevel,10) === 2) {
                            adjustedAddOns += 2;
                        } else if (parseInt(this.props.plans.current.planLevel, 10) === 7) {
                            adjustedAddOns += 3;
                        }
                    } else if (this.props.plans.current.addOns.add_on_social.qty === 1) {
                        adjustedAddOns = 1;
                    }
                } else {
                    if (this.props.isPlusUser(this.props.plans.current.planLevel) || this.props.isAgencyPlusUser(this.props.plans.current.planLevel)) {
                        if (this.props.plans.current.addOns.add_on_social.qty > 1) {
                            adjustedAddOns = Math.ceil((this.props.plans.current.addOns.add_on_social.qty + 1) / 2);
                        } else if (this.props.plans.current.addOns.add_on_social.qty === 1) {
                            adjustedAddOns = 1;
                        }
                    }

                }
                return adjustedAddOns;
            }

            return 0;

        }

        render() {
            return (
                <Component
                    {...this.props}
                    changeTerm={this.changeTerm}
                    confirmTermChange={this.confirmTermChange}
                    calculateAddOns={this.calculateAddOns}
                    getAdjustedAddOns={this.getAdjustedAddOns} />
            );
        }

    }

    PricingModule.displayName = "PricingModule";

    return PricingModule;
}
